import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";
import { applyBranding } from "./branding";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [business, setBusiness] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("wiqx_token");
    if (!token) {
      setUser(null);
      setBusiness(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setBusiness(data.business);
      applyBranding(data.business?.branding);
    } catch (e) {
      localStorage.removeItem("wiqx_token");
      setUser(null);
      setBusiness(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("wiqx_token", data.token);
    setUser(data.user);
    setBusiness(data.business);
    applyBranding(data.business?.branding);
    return data;
  };

  const signup = async (payload) => {
    const { data } = await api.post("/auth/signup", payload);
    localStorage.setItem("wiqx_token", data.token);
    setUser(data.user);
    setBusiness(data.business);
    applyBranding(data.business?.branding);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("wiqx_token");
    setUser(null);
    setBusiness(null);
  };

  return (
    <AuthContext.Provider value={{ user, business, setBusiness, loading, login, signup, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
